import { render, staticRenderFns } from "./educationExperience.vue?vue&type=template&id=2bebe832"
import script from "./educationExperience.vue?vue&type=script&lang=js"
export * from "./educationExperience.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports